export const SLUG_ALL_SPORTS: string = 'all'
export const SPORTS_LIMIT = 3
export const CASINO_LIMIT = 6
